import React from 'react';
import { P } from '../../components/Text/Text';

import styles from './unsavedChangesWarning.module.scss';

const UnsavedChangesWarningBody = () => {
    return (
        <P className={styles.text}>Do you want to cancel editing and lose all data entered on this page?</P>
    );
};

export default UnsavedChangesWarningBody;